import { Component, OnInit, Input } from '@angular/core';
import { DadosService } from '../../db/dados.service'
import {Router} from '@angular/router';

@Component({
  selector: 'app-carrinho',
  templateUrl: './carrinho.component.html',
  styleUrls: ['./carrinho.component.css']
})
export class CarrinhoComponent implements OnInit {
  constructor(private dados:DadosService, private router:Router) { 

  // console.log('carga carrinho');

  }

  ngOnInit() {
  }

  get carrinho(){
    //console.log(this.dados.carrinho.items);
    return this.dados.carrinho.items;
  }

  @Input() get total(){
    return this.dados.carrinho.total;
  }

  getCount(){
    return this.carrinho.length;
  }
  get count(){
    return this.getCount();
  }
  get subTotal(){
    return this.dados.carrinho.subTotal;
  }
  get freteTotal(){
    return this.dados.carrinho.freteTotal;
  }

  clearItems(){
    this.dados.regAnalytics(0,'acessos','carrinhoLimpar',1);

    this.dados.clear();
    this.continuar();
    this.router.navigate(['/']);
  }
  continuar(){
    this.dados.regAnalytics(0,'acessos','carrinhoContinuar',1);
    this.router.navigate(['/main']);
  }
  concluir(){
    this.dados.regAnalytics(0,'acessos','carrinhoConcluir',1);
    this.router.navigate(['/fechamento']);
  }
  excluirItem(x){
    //console.log(x);
    this.dados.deleteItem(x);
  }
 getNome(nome){
   if (nome.length<50)
     return nome ;
     else
     return nome.substring(0,50)+'...';
 }
}
